import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { I18nPropertyConfig } from "./propertyConfig.i18n";

/** */
export function getTimeSlotPropertyConfig(): PropertyConfig[] {
    return [
        {
            propertyName: "start",
            label: I18nPropertyConfig().timeslot.start,
            typeUid: PropertyConfigType.TIME_IN_SECONDS
        },
        {
            propertyName: "finish",
            label: I18nPropertyConfig().timeslot.finish,
            typeUid: PropertyConfigType.TIME_IN_SECONDS
        }
    ];
}